import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { background, compose, layout } from 'styled-system';

import Block from '../Block';

import Z_INDEX_SCALE from 'constants/zIndexScale';

const Overlay = styled(Block)`
  ${({ theme }) => css`
    opacity: ${theme.app.drawer.overlayOpacity};
    background: ${theme.colors.base.neutrals.gray900};
    overflow-x: hidden;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    z-index: ${Z_INDEX_SCALE.SIZE_5};

    ${theme.mediaQueries.lg} {
      opacity: ${theme.app.dropdown.overlayOpacity};
      overflow: hidden;
    }
  `}

  ${compose(layout, background)}
`;

export default Overlay;
